import { Reducer } from "redux";

import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

import {
    FAQ_ASK_QUESTION_FETCH_FAILURE,
    FAQ_ASK_QUESTION_FETCH_REQUEST,
    FAQ_ASK_QUESTION_FETCH_SUCCESS,
    FaqAskQuestionFetchFailureAction,
    FaqAskQuestionFetchRequestAction,
    FaqAskQuestionFetchSuccessAction,
} from "./FaqAskQuestion.actions";

export interface AskQuestionState {
    errorMessage: string;
    loadingState: LoadingState;
    prefillText: string;
    question: string;
}

export const initialAskQuestionState: AskQuestionState = {
    errorMessage: null,
    loadingState: LoadingState.INIT,
    prefillText: "",
    question: "",
};

export interface FaqAskQuestionPageState {
    [faqId: string]: AskQuestionState;
}

const initialFaqAskQuestionPageState: FaqAskQuestionPageState = {};

declare type FaqAskQuestionPageReducerAction =
    | FaqAskQuestionFetchRequestAction
    | FaqAskQuestionFetchSuccessAction
    | FaqAskQuestionFetchFailureAction;

const faqAskQuestionPageReducer: Reducer<
    FaqAskQuestionPageState,
    FaqAskQuestionPageReducerAction
> = (state = initialFaqAskQuestionPageState, action) => {
    switch (action.type) {
        case FAQ_ASK_QUESTION_FETCH_REQUEST:
        case FAQ_ASK_QUESTION_FETCH_FAILURE: {
            const faqId = action.faqId;
            return tupdate(state, {
                [faqId]: tupdate(state[faqId] || initialAskQuestionState, {
                    errorMessage: errorMessage(undefined, action),
                    loadingState: loadingState(undefined, action),
                }),
            });
        }

        case FAQ_ASK_QUESTION_FETCH_SUCCESS: {
            const faqId = action.faqId;
            return tupdate(state, {
                [faqId]: tupdate(state[faqId] || initialAskQuestionState, {
                    errorMessage: errorMessage(undefined, action),
                    loadingState: loadingState(undefined, action),
                    prefillText: action.response.result.prefillText,
                    question: action.response.result.question,
                }),
            });
        }

        default:
            return state;
    }
};

export default faqAskQuestionPageReducer;
